import { axiosInstance } from './apiCommon';

export type NotificationRecipientType = 'All' | 'Role' | 'User' | 'Company';

export interface AdminNotificationRecipientModel {
  recipientType: NotificationRecipientType | string;
  roleId?: string | null;
  userId?: string | null;
  companyId?: string | null;
}

export interface AdminNotificationModel {
  id: string;
  title: string;
  body: string;
  category: string;
  publishedAt: string;
  validFrom?: string | null;
  validTo?: string | null;
  isPublished: boolean;
  recipients: AdminNotificationRecipientModel[];
  createdAt: string;
  createdBy?: string | null;
  modifiedAt: string;
  modifiedBy?: string | null;
}

export interface AdminNotificationCreateModel {
  title: string;
  body: string;
  category: string;
  publishedAt?: string | null;
  validFrom?: string | null;
  validTo?: string | null;
  isPublished: boolean;
  recipients: AdminNotificationRecipientModel[];
}

const BASE = '/api/admin/v1/AdminNotifications';

export interface AdminNotificationPagedResult {
  items: AdminNotificationModel[];
  total: number;
}

export const getAdminNotifications = async (page = 1, pageSize = 20): Promise<AdminNotificationPagedResult> => {
  return (await axiosInstance.get<AdminNotificationPagedResult>(BASE, { params: { page, pageSize } })).data;
};

export const createAdminNotification = async (data: AdminNotificationCreateModel): Promise<AdminNotificationModel> => {
  return (await axiosInstance.post<AdminNotificationModel>(BASE, data)).data;
};

export const updateAdminNotification = async (id: string, data: AdminNotificationCreateModel): Promise<void> => {
  await axiosInstance.put(`${BASE}/${id}`, data);
};

export const deleteAdminNotification = async (id: string): Promise<void> => {
  await axiosInstance.delete(`${BASE}/${id}`);
};

export interface LookupRoleModel {
  id: string;
  name: string;
}

export interface LookupCompanyModel {
  id: string;
  name: string;
}

export const getAdminNotificationRoles = async (): Promise<LookupRoleModel[]> => {
  return (await axiosInstance.get<LookupRoleModel[]>(`${BASE}/roles`)).data;
};

export const getAdminNotificationCompanies = async (): Promise<LookupCompanyModel[]> => {
  return (await axiosInstance.get<LookupCompanyModel[]>(`${BASE}/companies`)).data;
};

export interface LookupUserModel {
  id: string;
  displayName: string;
  email: string;
}

export const getAdminNotificationUsers = async (search?: string, take = 50): Promise<LookupUserModel[]> => {
  const params: Record<string, string | number> = { take };
  if (search && search.trim()) params.search = search.trim();
  return (await axiosInstance.get<LookupUserModel[]>(`${BASE}/users`, { params })).data;
};

export const getAdminNotificationUsersByIds = async (ids: string[]): Promise<LookupUserModel[]> => {
  if (ids.length === 0) return [];
  return (
    await axiosInstance.get<LookupUserModel[]>(`${BASE}/users`, {
      params: { ids: ids.join(','), take: ids.length },
    })
  ).data;
};
